import { lazy } from "react";
import { authRoleAccess } from "../../auth/AuthRoleAccess";

const GuestHubAdmin = lazy(() => import("./GuestHubAdmin"));

const guestHubAdminRoutes = [
  {
    path: "/guest-hub-admin",
    component: GuestHubAdmin,
    auth: authRoleAccess.guestHubAdmin,
  },
];

export default guestHubAdminRoutes;
